import { loc } from '../lib/_location.js';
import { load } from '../lib/_load.js';
export const API_URL = "https://ranking-api.sys-kanri-e61.workers.dev/api/ranking";
export let setting = {
	max: 0,
	len: 0,
	isSP: false,
	getData: function(){
		return new Promise((resolve, reject) => {
			let url = `/assets/json/persons.json`;
			setting.max = setting.getLength();
			load.getJson(url, {}).then( (res) => {
				return resolve(res);
			});
		});
	},
	getLength: function(){
		let info = loc.all();
		let params = info.params;
		//console.log(params);
		let PCL 	= 12;
		let SPL 	= 12;
		
		//let PCL 	= 1;
		//let SPL 	= 1;
		/*
		if( params.num ){
			PCL = params.num;
			SPL = params.num;
		}
		*/
		//URLの引数によってカード枚数を変更
		
		let winW = window.innerWidth;
		let $html = document.documentElement;
		let len = 0;
		if( $html.classList.contains("mobile") ){
			len = SPL;
		}else{
			len = PCL;
		}
		return len;
	}
}
export let getTime = (ms) =>{
	const min 	= String(Math.floor(ms / 60000)).padStart(2, "0");
	const sec 	= String(Math.floor((ms % 60000) / 1000)).padStart(2, "0");
	const milli = String(Math.floor(ms % 1000)).padStart(3, "0");
	
	let time = `${min}:${sec}:${milli}`;
	return time;
}